// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"pD-z","smallCardRow":"qD-z","largeCardRow":"rD-z","productSearchRow":"sD-z","curatedRow":"tD-z"};